function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.571 25.429H30A4.571 4.571 0 0 1 25.429 30H0V7.088h4.571v9.732l18.578.032a4.547 4.547 0 0 1-4.555 4.547l-14.023-.024v4.054z",
  fill: "#1063CD"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.429 4.571H0A4.571 4.571 0 0 1 4.571 0H30v22.903h-4.571v-9.716H6.85v-.024a4.547 4.547 0 0 1 4.548-4.547h14.03V4.571z",
  fill: "#1063CD"
});

const SvgLogo = props => React.createElement("svg", _extends({
  viewBox: "0 0 30 30",
  fill: "none"
}, props), _ref, _ref2);

export default SvgLogo;